module.exports = __webpack_public_path__ + "img/blog-5-2.a5978e90.webp";